//@ts-check
import React from 'react'
import { Switch } from '@progress/kendo-react-inputs'
import './inputSwitchHLPure.css'
import { TooltipHLPure } from './../index'

/**
 * Input switch with label and tooltip
 * @component
 * @example
 * const props = {
 *  labelInput: 'Label',
 *  customClass: 'custom-class',
 *  required: true,
 *  customLabelClass: 'custom-label-class',
 *  showTooltip: true,
 *  positionTooltip: 'top' | 'bottom' | 'left' | 'right',
 *  titleTooltip: 'Title',
 *  descriptionTooltip: 'Description',
 *  subContent: <div>Sub content</div> || 'Subcontent',
 *  restContent: <div>Rest content</div> || 'Rest content',
 *  informationIcon: true,
 *  checked: false,
 *  onChange: (e) => console.log(e.value)
 * }
 * return (
 *  <InputSwitchHLPure {...props} />
 * )
 * @param {Object} props - Props for the component
 * @param {string} props.labelInput - Label for the switch
 * @param {string} [props.customClass] - Custom class for the container
 * @param {boolean} [props.required] - If true, shows an asterisk next to the label
 * @param {string} [props.customLabelClass] - Custom class for the label
 * @param {boolean} [props.showTooltip] - If true, shows the tooltip
 * @param {string} [props.positionTooltip] - Position of the tooltip: 'top', 'bottom', 'left', 'right'
 * @param {string} [props.titleTooltip] - Title of the tooltip
 * @param {string} [props.descriptionTooltip] - Description of the tooltip
 * @param {React.ReactNode|string} [props.subContent] - Sub content of the tooltip
 * @param {React.ReactNode|string} [props.restContent] - Rest content of the tooltip
 * @param {boolean} [props.informationIcon] - If true, shows the information icon in the tooltip
 * @param {boolean} [props.checked] - If true, the switch is on
 * @param {((event: import('@progress/kendo-react-inputs').SwitchChangeEvent) => void) | undefined} [props.onChange] - Function to call when the switch is toggled
 * @returns {JSX.Element} The rendered component
 */
const InputSwitchHLPure = (props) => {
    let {
        labelInput,
        customClass,
        required,
        customLabelClass,
        showTooltip,
        positionTooltip,
        titleTooltip,
        descriptionTooltip,
        subContent,
        restContent,
        informationIcon
    } = props

    return (
        <div className={customClass || 'inputSwitchHLPure-container'}>
            {
                labelInput ? (
                    <>
                        <label className={customLabelClass || 'inputSwitchHLPure-label'}>
                            {labelInput}{required && '*'}
                        </label>
                        {
                            showTooltip && (
                                <div className='inputSwitchHLPure-tooltip'>
                                    <TooltipHLPure
                                        {...props}
                                        positionTooltip={positionTooltip}
                                        titleTooltip={titleTooltip}
                                        descriptionTooltip={descriptionTooltip}
                                        subContent={subContent}
                                        restContent={restContent}
                                        informationIcon={informationIcon}
                                    />
                                </div>
                            )
                        }
                        <Switch
                            {...props}
                        />
                    </>
                ) : (
                    <Switch
                        {...props}
                    />
                )
            }
        </div>
    )
}

export { InputSwitchHLPure as default }